// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ks-0";